import { render, staticRenderFns } from "./editCommunityWechat.vue?vue&type=template&id=4b394c5d"
import script from "./editCommunityWechat.vue?vue&type=script&lang=js"
export * from "./editCommunityWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports